// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"ConfirmationModal_confirmButton_BQRFX"};